import { render, staticRenderFns } from "./areaReviewList.vue?vue&type=template&id=091d7d5f&scoped=true&"
import script from "./areaReviewList.vue?vue&type=script&lang=js&"
export * from "./areaReviewList.vue?vue&type=script&lang=js&"
import style0 from "./areaReviewList.vue?vue&type=style&index=0&id=091d7d5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091d7d5f",
  null
  
)

export default component.exports